import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';
import type { Moment } from 'moment';

import { ChunkLoadErrorBoundary } from '@trello/error-reporting';
import { useLazyComponent } from '@trello/use-lazy-component';

import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

export enum Choice {
  StartDate,
  DueDate,
}

export const LazyCardDateRangePicker: FunctionComponent<{
  due?: Moment | Date | number | string | null | undefined;
  start?: Moment | Date | number | string | null | undefined;
  dueReminder?: number | null;
  idCard: string;
  idBoard?: string;
  idOrg?: string;
  hidePopover: () => void;
  initialChoice?: Choice;
}> = ({
  due,
  start,
  dueReminder,
  idCard,
  idBoard,
  idOrg,
  hidePopover,
  initialChoice,
}) => {
  const CardDateRangePicker = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "card-date-range-picker" */ './CardDateRangePicker'
      ),
    { namedImport: 'CardDateRangePicker' },
  );
  return (
    <ComponentWrapper key="date-range-picker">
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <CardDateRangePicker
            due={due}
            start={start}
            dueReminder={dueReminder}
            idCard={idCard}
            idBoard={idBoard}
            idOrg={idOrg}
            hidePopover={hidePopover}
            initialChoice={initialChoice}
          />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ComponentWrapper>
  );
};
